import 'core-js/stable';
import 'bootstrap';
import '../navbar';
import setupSentry from '../sentry';

setupSentry();
